/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";
import * as Actions from "actions";
import {Container} from "@mui/material";

import ShopProductSearch from "components/widgets/user/ShopProductSearch";

import ShopHeaderMini from "components/elements/user/shops/ShopHeaderMini";
import ShopHeaderInfo from "components/elements/user/shops/ShopHeaderInfo";
import ShopProductPopularSlider from "components/elements/user/products/ShopProductPopularSlider";
import ShopProductNewSlider from "components/elements/user/products/ShopProductNewSlider";
import ShopOffersSlider from "components/elements/user/offers/ShopOffersSlider";
import ShopProductsList from "components/elements/user/products/ShopProductList";


import {isMarketPlace} from "helpers/utils";
import ShopHeaderNav from "components/elements/user/shops/ShopHeaderNav";


const ShopSiteHomeMain = (props) => {

  const [state] = useState({
    layoutColumns: 3,
    storeid: "NA",
  });

  const {
    match, bootupInfo, history
  } = props;

  const shopId = (isMarketPlace() ? match.params.shopId : bootupInfo.appState.subdomain_shopId);

  useEffect(() => {

    props.userResetSearchProducts();
    //props.usergetProductCategories(props.bootupInfo.appState.subdomain_shopId,
    //  true, props.bootupInfo.appState.isWebsite);

  }, []);

    const refetch = () => {
    //    props.usergetProductCategories(props.bootupInfo.appState.subdomain_shopId,
    //        true, props.bootupInfo.appState.isWebsite);
    };

    return (
    <div>
      {/* SEO Support */}
      <Helmet>
        <title>{props.bootupInfo.shopinfo.title}</title>
        <meta name="description" content={props.bootupInfo.shopinfo.title} />
      </Helmet>
      {/* SEO Support End */}

      {isMarketPlace() && <ShopHeaderNav history={history} />}

      {isMarketPlace() ?
            <ShopHeaderMini {...props} /> : <ShopHeaderInfo {...props} /> }

      <ShopProductSearch {...props} shopId={shopId} colSize={state.layoutColumns} />

      {/*
      <Container>
        <CategoryTitleSlider {...props} refetch={refetch} />
      </Container>
      */}

      <ShopProductPopularSlider shopId={shopId} />

      <ShopOffersSlider shopId={shopId} />

      {/*
      <CategoryMenuSlider {...props} />
      */}

      <ShopProductNewSlider shopId={shopId} />

      <ShopProductsList shopId={shopId} />
    </div>
  );
};

ShopSiteHomeMain.propTypes = {
  userResetSearchProducts: PropTypes.func.isRequired,
  usergetProductCategories: PropTypes.func.isRequired,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
};

const _ShopSiteHomeMain = connect(
  ({ userproducts, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userproducts.reqStatus,
    isLoading: userproducts.isLoading,
    serviceError: userproducts.serviceError,
    categoryList: userproducts.categoryList,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopSiteHomeMain);

export { _ShopSiteHomeMain as default };
